import React, { useCallback, useMemo } from 'react';
import styles from './Performance.module.css';
import { MuiTab, MuiPaper } from '@ace/ace-ui-web';
import Overall from './tabs/overall/Overall';
import Ecommerce from './tabs/ecommerce/Ecommerce';
import LocalLiftMax from './tabs/localliftmax/LocalLiftMax';
import PerformancePeerGroup from './PerformancePeerGroup';
import lang from '../../languages/en.json';
import { useClickHandler } from '../../utils/usageMetricsLogger';

const PAGE_NM = 'Performance';

const Performance: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState<number>(0);
  const handleAndLogClick = useClickHandler(PAGE_NM);

  const tabs = useMemo(
    () => [
      {
        label: lang.overallPerformanceContent.overall,
        content: <Overall />,
      },
      {
        label: lang.overallPerformanceContent.ecommerce,
        content: <Ecommerce />,
      },
      {
        label: lang.overallPerformanceContent.localLift,
        content: <LocalLiftMax />,
      },
    ],
    [],
  );

  const handleTabChange = useCallback(
    (tabIndex: number): void => {
      setActiveTab(tabIndex);
      handleAndLogClick(tabs[tabIndex]?.label);
    },
    [handleAndLogClick, tabs],
  );

  return (
    <div className={styles.container}>
      <PerformancePeerGroup />
      <MuiPaper
        elevation={0}
        height="auto"
        square
        width="100%"
        sx={{ marginTop: '24px' }}>
        <MuiTab
          fontSize="default"
          fontWeight="default"
          tabs={tabs}
          scrollable
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            marginBottom: '20px',
          }}
        />
      </MuiPaper>
    </div>
  );
};

export default Performance;
